import { isWorkoutDebited } from './workoutDebit';

/** YYYY-MM-DD для поля date тренировки */
export function workoutCalendarDayKey(w) {
  if (!w?.date) return '';
  const d = String(w.date);
  return d.includes('T') ? d.split('T')[0] : d.slice(0, 10);
}

/**
 * Повторяет логику paymentWalletMeta из TrainerMain для одного клиента:
 * множество id тренировок со статусом «не оплачено» (красная плашка).
 *
 * @param {Array<Object>} workouts - тренировки клиента (как из GET /client/:id/workouts)
 * @param {number} balance - из GET /clients/:id/balance (поле balance)
 * @param {Date} [now] - опорное время
 * @returns {Set<string|number>}
 */
export function computeClientUnpaidWorkoutIds(workouts, balance, now = new Date()) {
  const unpaidIds = new Set();

  const list = Array.isArray(workouts) ? workouts : [];
  const bal = typeof balance === 'number' && Number.isFinite(balance) ? balance : 0;

  const workoutStartMs = (w) => {
    try {
      const day = workoutCalendarDayKey(w);
      if (!day) return 0;
      const ms = new Date(`${day}T${w.time || '00:00'}`).getTime();
      return Number.isFinite(ms) ? ms : 0;
    } catch {
      return 0;
    }
  };

  const debited = list.filter(
    (w) =>
      isWorkoutDebited(w, now) && w.status !== 'cancelled' && w.status !== 'transferred'
  );

  const debitedSorted = [...debited].sort((a, b) => workoutStartMs(a) - workoutStartMs(b));

  if (bal < 0) {
    const n = debitedSorted.length;
    const paySlots = Math.max(0, Math.round(n + bal));
    debitedSorted.slice(paySlots).forEach((w) => unpaidIds.add(w.id));
    const upcoming = list
      .filter(
        (w) =>
          !isWorkoutDebited(w, now) &&
          w.status !== 'cancelled' &&
          w.status !== 'transferred' &&
          w.status !== 'skipped'
      )
      .sort((a, b) => workoutStartMs(a) - workoutStartMs(b));
    upcoming.forEach((w) => unpaidIds.add(w.id));
  }

  // bal >= 0: первые min(bal, N) предстоящих считаются покрытыми оплатой; остальные — нет.
  // При bal === 0 покрытых нет → все предстоящие неоплачены (раньше ветка bal > 0 их пропускала).
  if (bal >= 0) {
    const upcoming = list
      .filter(
        (w) =>
          !isWorkoutDebited(w, now) &&
          w.status !== 'cancelled' &&
          w.status !== 'transferred' &&
          w.status !== 'skipped'
      )
      .sort((a, b) => workoutStartMs(a) - workoutStartMs(b));
    if (upcoming.length > 0) {
      const coveredCount = Math.min(bal, upcoming.length);
      const beyond = upcoming.slice(coveredCount);
      beyond.forEach((w) => unpaidIds.add(w.id));
    }
  }

  return unpaidIds;
}
